import { categories, articles } from "@/mocks/home";

export interface BreadcrumbItem {
  name: string;
  url: string;
}

const siteUrl = "https://www.91madou.com";
const siteName = "91麻豆免费视频网站";
const siteDescription = "91麻豆免费视频网站打造综合性影视在线观看平台，集合91年国产影片视频、91传媒视频在线、91精彩视频在线观看等频道，影视网站免费观看热门影视在线，在线视频平台电影电视剧综艺全覆盖。";

const pageTitles: Record<string, string> = {
  "/": "91麻豆免费视频网站_91年国产影片视频_91传媒视频在线_91精彩视频在线观看",
  "/about": "关于我们 - 91麻豆免费视频网站",
};

export function getOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteName,
    url: siteUrl,
    description: siteDescription,
    email: "contact@91madou.com",
    telephone: "400-888-9191",
    address: {
      "@type": "PostalAddress",
      addressLocality: "北京",
      addressRegion: "北京",
      addressCountry: "CN",
      streetAddress: "北京市朝阳区建国路88号SOHO现代城A座",
    },
  };
}

export function getWebSiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: siteName,
    url: siteUrl,
    description: siteDescription,
    potentialAction: {
      "@type": "SearchAction",
      target: `${siteUrl}/search?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };
}

export function getWebPageSchema(path: string, breadcrumbs: BreadcrumbItem[]) {
  const pageTitle = pageTitles[path] || siteName;
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: pageTitle,
    url: `${siteUrl}${path}`,
    description: siteDescription,
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: breadcrumbs.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.name,
        item: item.url,
      })),
    },
  };
}

export function getBreadcrumbSchema(breadcrumbs: BreadcrumbItem[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: breadcrumbs.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function getArticleSchema(articleSlug: string) {
  const article = articles.find((a) => a.slug === articleSlug);
  if (!article) return null;
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: article.title,
    author: {
      "@type": "Person",
      name: article.author,
    },
    datePublished: article.date,
    description: article.summary,
    url: `${siteUrl}/article/${article.slug}`,
    publisher: {
      "@type": "Organization",
      name: siteName,
    },
  };
}

export function getFAQSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "91麻豆免费视频网站有哪些影视内容？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "91麻豆免费视频网站涵盖电影、电视剧、综艺、动漫、纪录片、短视频等全品类影视内容，包括91年国产影片视频、91传媒视频在线、91精彩视频在线观看等多个特色频道。",
        },
      },
      {
        "@type": "Question",
        name: "91麻豆免费视频网站是否需要注册？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "91麻豆免费视频网站目前提供免费在线观看服务，无需注册即可浏览和观看大部分影视内容，方便快捷。",
        },
      },
      {
        "@type": "Question",
        name: "91麻豆免费视频网站支持哪些设备观看？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "91麻豆免费视频网站支持电脑、平板、手机等多种设备，用户可以通过浏览器直接访问，随时随地观看喜爱的影视内容。",
        },
      },
      {
        "@type": "Question",
        name: "91麻豆免费视频网站的内容更新频率如何？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "91麻豆免费视频网站每日更新100+部影视内容，确保用户能够第一时间观看到最新上线的电影、电视剧和综艺节目。",
        },
      },
      {
        "@type": "Question",
        name: "如何联系91麻豆免费视频网站的客服？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "您可以通过发送邮件至contact@91madou.com，或拨打客服电话400-888-9191联系我们的客服团队，也可以通过网站'关于我们'页面的留言表单提交您的问题。",
        },
      },
    ],
  };
}

export function getCategoryPageSchema(slug: string, breadcrumbs: BreadcrumbItem[]) {
  const category = categories.find((c) => c.slug === slug);
  return {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: category ? `${category.name} - ${siteName}` : siteName,
    url: `${siteUrl}/category/${slug}`,
    description: category
      ? `浏览${category.name}分类下的精彩影视内容 - ${siteName}`
      : siteDescription,
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: breadcrumbs.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.name,
        item: item.url,
      })),
    },
  };
}